export default "__VITE_ASSET__D$D0$RrV__"